import "./ConceptBanner.css";

interface ConceptBannerProps {
  /** One line naming what's being previewed. Completes "Not live in EasyFarm yet — ___". */
  detail: string;
}

/**
 * The concept label every static "picture Christy talks to" screen must
 * carry (`docs/demo/tradeshow-2026-09.md`, "Static booth material"):
 *
 *   "Keep these clearly labeled as concept in the UI. A prospect who thinks
 *   the roll-up ships today and finds out later is a worse outcome than one
 *   who was told it's coming."
 *
 * That is why this is a real, permanent element of the layout — not a small
 * grey footnote easy to miss across a booth table — and why it is its OWN
 * visual language rather than borrowed:
 *
 *   - NOT the gold-wash strip InsightCard uses. That means "the assistant is
 *     talking"; reusing it here would make a concept screen look like a live
 *     AI feature, which is the exact confusion this component exists to
 *     prevent.
 *   - NOT the dark hero panel KpiCard uses. That means "the number that
 *     matters"; a concept banner is not a number that matters, it is a
 *     disclosure.
 *   - A dashed border instead, reading as "sketch" the way a solid one reads
 *     as "shipped" — reinforced by the word CONCEPT itself, per
 *     `rules/ui-breadcrumbs.md` §1: color/style is never the only channel.
 *
 * Reusable on purpose: `docs/demo/tradeshow-2026-09.md` lists more static
 * concept screens as "worth having" (H-2A, Paid Leave, the native app
 * screenshot) — this is the shared element they should all carry.
 */
export function ConceptBanner({ detail }: ConceptBannerProps) {
  return (
    <div className="concept-banner">
      <span className="concept-banner__tag">Concept</span>
      <p className="concept-banner__detail">Not live in EasyFarm yet — {detail}</p>
    </div>
  );
}
